import { navigate } from 'gatsby';
import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { useMenuContext } from '~src/context/menu-context';
import { MenuList, menuList } from '~src/data';

import { DrawerBody } from '../modal';
import { Form } from './form';

const Body = styled(DrawerBody)`
  margin-top: 6em;
  padding: 0.5rem 3rem;
  display: flex;
  justify-content: center;
`;

const Container = styled.div<{ isOpenContact: boolean }>`
  max-width: ${p => (p.isOpenContact ? `63em` : `53em`)};
  width: 100%;
`;

const LinkList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const List = styled.ul`
  flex: 1;
`;

const UnderLine = styled.div`
  position: absolute;
  bottom: -4px;
  left: 0;
  right: 100%;
  height: 1px;
  background-color: ${p => p.theme.colors.red};
  pointer-events: none;
  opacity: 0;
  transition: all 0.2s ease;
`;

const Image = styled.div`
  flex: 1;
  max-width: 24.58em;
  width: 100%;
  height: 14.38em;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  ${p => p.theme.maxWidth.phone`
    display: none;
  `}
`;

const Img = styled.img`
  object-fit: cover;
  object-position: center center;
  opacity: 1;
  transition: opacity 500ms ease 0s;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const RedBoderHorizontal = styled.div`
  background-color: ${p => p.theme.colors.red};
  height: 0.3125em;
  width: 8em;
  position: absolute;
  top: -0.3125em;
  right: -0.3125em;
`;

const RedBoderVerikal = styled.div`
  background-color: ${p => p.theme.colors.red};
  height: 8em;
  width: 0.3125em;
  position: absolute;
  top: -0.3125em;
  right: -0.3125em;
`;

const ListItem = styled.li`
  padding: 0.4em 0;
`;

const LinkLabel = styled.span``;

const Link = styled.button`
  position: relative;
  font-size: 1.125em;
  font-weight: 500;
  color: #000;
  transition: font-weight 0.2s ease;
  text-transform: initial;

  &:hover {
    color: ${p => p.theme.colors.redDark};

    ${UnderLine} {
      opacity: 1;
      right: 0;
    }
  }
`;

type Props = {
  isOpenContact: boolean;
  onCloseMenu: () => void;
};

export const MenuBody: FC<Props> = ({ isOpenContact, onCloseMenu }) => {
  const [isHovered, setIshovered] = useState(1);
  const { setmMenuState } = useMenuContext();
  return (
    <Body>
      <Container isOpenContact={isOpenContact}>
        {!isOpenContact ? (
          <LinkList>
            <List>
              {menuList.map((el: MenuList[number]) => (
                <ListItem key={el.id}>
                  <Link
                    onClick={() => {
                      setmMenuState({ sceneID: el.sceneID, coords: el.coords });
                      navigate('/izlozbeni-prostor/');
                      onCloseMenu();
                    }}
                    data-text={el.label}
                  >
                    <LinkLabel onMouseEnter={() => setIshovered(el.id)}>
                      {el.label}
                    </LinkLabel>
                    <UnderLine />
                  </Link>
                </ListItem>
              ))}
            </List>
            <Image>
              <RedBoderHorizontal />
              <RedBoderVerikal />
              <Img
                src={menuList[isHovered - 1].image}
                alt={menuList[isHovered - 1].label}
                loading="lazy"
              />
            </Image>
          </LinkList>
        ) : (
          <Form />
        )}
      </Container>
    </Body>
  );
};
